export default "__VITE_ASSET__CdqkDfUM__"